import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './style.css';

const Card = React.forwardRef(
  ({ title, className, children, shadow, footer: Footer, ...rest }, ref) => {
    const customClassName = classNames('card', className, {
      '-shadow': shadow,
    });
    return (
      <article className={customClassName} ref={ref} {...rest}>
        <div className="card-wrapper">
          {title ? (
            <header className="card-header">
              <h4 className="card-title">{title}</h4>
            </header>
          ) : null}
          <div className="card-content">{children}</div>
          {Footer ? (
            <footer className="card-footer">
              <Footer />
            </footer>
          ) : null}
        </div>
      </article>
    );
  }
);

Card.propTypes = {
  title: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  footer: PropTypes.func,
  shadow: PropTypes.bool,
};

Card.defaultProps = {
  title: null,
  className: null,
  children: null,
  footer: null,
  shadow: true,
};

export default Card;
